const actionType = {
    GET_GC_CONTEXT_SUCCESS: 'GET_GC_CONTEXT_SUCCESS',
    SAVE_GC_CONTEXT_SUCCESS: 'SAVE_GC_CONTEXT_SUCCESS',
    CLEAN_GC_CONTEXT: 'CLEAN_GC_CONTEXT',
};

export default actionType;
